import Skeleton from '../common/Skeleton';

const CalendarSkeleton = () => {
  return (
    <div className="max-w-7xl mx-auto">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700">
        {/* Header Skeleton */}
        <div className="p-6 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Skeleton className="h-8 w-32" />
              <div className="flex items-center gap-2">
                <Skeleton className="h-9 w-9" />
                <Skeleton className="h-9 w-9" />
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="h-9 w-24" />
              <Skeleton className="h-9 w-32" />
            </div>
          </div>
        </div>

        {/* Calendar Grid Skeleton */}
        <div className="p-6">
          {/* Week Days */}
          <div className="grid grid-cols-7 gap-px mb-4">
            {[...Array(7)].map((_, i) => (
              <div key={i} className="text-center">
                <Skeleton className="h-5 w-12 mx-auto" />
              </div>
            ))}
          </div>

          {/* Calendar Days */}
          <div className="grid grid-cols-7 gap-px">
            {[...Array(35)].map((_, i) => (
              <div key={i} className="aspect-square p-2 border border-gray-200 dark:border-gray-700">
                <div className="h-full flex flex-col">
                  <Skeleton className="h-6 w-6 mb-2" />
                  {Math.random() > 0.5 && (
                    <div className="space-y-1">
                      <Skeleton className="h-4 w-full" />
                      <Skeleton className="h-4 w-3/4" />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Events List Skeleton */}
        <div className="p-6 border-t border-gray-200 dark:border-gray-700">
          <Skeleton className="h-6 w-32 mb-4" />
          <div className="space-y-3">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="flex items-start gap-4">
                <Skeleton className="h-12 w-12 rounded-lg" />
                <div className="flex-1">
                  <Skeleton className="h-5 w-48 mb-2" />
                  <Skeleton className="h-4 w-32" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarSkeleton; 